'use client';

import { c as _c } from "react/compiler-runtime";
import { AppAdvertisement } from '@/components/app-advertisement';
import type { Locale } from '@/types/types';
import { usePathname } from 'next/navigation';
import React from 'react';
interface Properties {
  appNavBar: React.ReactNode;
  copyrightArea: React.ReactNode;
  locale: Locale;
  isAppMode: boolean;
}

/**
 * Client-side wrapper for the global footer to handle dynamic visibility during navigation.
 * It ensures the App Advertisement disappears when navigating away from /app/* routes.
 */
export const GlobalAppFooterClientWrapper: React.FC<Properties> = t0 => {
  const $ = _c(10);
  const {
    appNavBar,
    copyrightArea,
    locale,
    isAppMode
  } = t0;
  const pathname = usePathname();
  const isAppPath = pathname.split("/").includes("app");
  if (isAppMode) {
    let t1;
    if ($[0] !== appNavBar) {
      t1 = <>{appNavBar}</>;
      $[0] = appNavBar;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (isAppPath) {
    let type = "generic";
    if (pathname.includes("/app/map")) {
      type = "map";
    } else {
      if (pathname.includes("/app/chat")) {
        type = "chat";
      }
    }
    let t1;
    if ($[2] !== locale || $[3] !== type) {
      t1 = <AppAdvertisement locale={locale} type={type} />;
      $[2] = locale;
      $[3] = type;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    if ($[5] !== copyrightArea || $[6] !== t1) {
      t2 = <>{t1}{copyrightArea}</>;
      $[5] = copyrightArea;
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t1;
  if ($[8] !== copyrightArea) {
    t1 = <>{copyrightArea}</>;
    $[8] = copyrightArea;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};